import React, { useEffect } from 'react'
import Card from '../component/Card'
import { useCookies } from 'react-cookie'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSmile } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import { useProductContext } from '../providers/ProductProvider'
import { GridLoader } from 'react-spinners'
const Dashboard = () => {
    const navigate=useNavigate()
    const [cookies,setCookies,removeCookie]=useCookies(["auth_token"])
    const  auth_token=cookies["auth_token"]
    const fullName=localStorage.getItem("user_name")
const {data ,loading}=useProductContext()
useEffect(()=>{
    if(!auth_token){navigate("/login")}
},[auth_token,fullName])
  return (
    <div className='container'>
        {
            auth_token?(
                        <h3 className='text-center text-secondary mt-4'> Welcome back <b>{fullName} <FontAwesomeIcon icon={faSmile}/></b></h3>

            ):''
        }
        <div>
        {
      loading? (
        <div className=' container-fluid d-flex align-items-center justify-content-center '  style={{marginTop:"10%" ,marginBottom:"10%"}}> 
          <GridLoader color="#ADD8E6" /><b style={{color:"#ADD8E6"}}> Loading...</b>
        </div>
      ):(
      <div className='container'>
            
      <div className='row'>
        {
          data?.map((e)=>(
            <Card key={e._id} data={e}/>
          ))
        }
      </div>
    </div>
      )
    }
        </div>
            
    </div>
  )
}

export default Dashboard
